import classNames from 'classnames';
import { useCallback, useState } from 'react';
import useResizeLayout from '@Hooks/useResizeLayout';
import { ReactComponent as DocumentPlus } from '@Icons/additional/document-plus.svg';
import { Flex } from 'antd';
import { useGetProfileAssetsQuery } from '@Store/api/dictionaryApiSlice';

import styles from './asset.module.css';
import TabSwitch from './TabSwitch/TabSwitch';
import { AssetsProfileTab } from './Tab.enum';
import { AssetsTab, SoftwareTab } from './TabLayouts';

const AssetLayout: React.FC = () => {
  const { isMobile } = useResizeLayout();
  const { data, isSuccess } = useGetProfileAssetsQuery();
  const [activeTab, setActiveTab] = useState(AssetsProfileTab.ASSETS);

  const handleChangeTab = useCallback((tab: AssetsProfileTab) => {
    setActiveTab(tab);
  }, []);

  return (
    <div className={styles.wrapper}>
      {!isMobile && (
        <>
          <Flex className={styles.header}>
            <div className={styles.title}>{activeTab}</div>
            <div className={styles.actionItems}>
              <TabSwitch tab={activeTab} changeTab={handleChangeTab} />
              <div
                className={classNames(
                  styles.searchItem,
                  'trojan-neumorphism-box trojan-neumorphism-box-shadow'
                )}
              >
                <DocumentPlus />
              </div>
            </div>
          </Flex>
          {activeTab === AssetsProfileTab.ASSETS && (
            <AssetsTab data={data?.Assets || []} isSuccess={isSuccess} />
          )}
          {activeTab === AssetsProfileTab.SOFTWARE && (
            <SoftwareTab
              data={data?.SoftwareAssets || []}
              isSuccess={isSuccess}
            />
          )}
        </>
      )}

      {isMobile && (
        <Flex vertical gap={8}>
          <div
            className={classNames(
              styles.searchItem,
              'trojan-neumorphism-box trojan-neumorphism-box-shadow'
            )}
          >
            <DocumentPlus />
          </div>
          <TabSwitch tab={activeTab} changeTab={handleChangeTab} />
          <div className={styles.assetTabContainer}>
            {activeTab === AssetsProfileTab.ASSETS && (
              <AssetsTab data={data?.Assets || []} isSuccess={isSuccess} />
            )}
            {activeTab === AssetsProfileTab.SOFTWARE && (
              <SoftwareTab
                data={data?.SoftwareAssets || []}
                isSuccess={isSuccess}
              />
            )}
          </div>
        </Flex>
      )}
    </div>
  );
};

export default AssetLayout;
